import { render, staticRenderFns } from "./show.vue?vue&type=template&id=4e945e0a&scoped=true"
import script from "./show.vue?vue&type=script&lang=js"
export * from "./show.vue?vue&type=script&lang=js"
import style0 from "./show.vue?vue&type=style&index=0&id=4e945e0a&prod&lang=css"
import style1 from "./show.vue?vue&type=style&index=1&id=4e945e0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e945e0a",
  null
  
)

export default component.exports